import { Injectable } from "@angular/core"
import { Actions, Effect } from "@ngrx/effects"
import { Action } from "@ngrx/store"
import { WorkshopService } from "@services/workshop"
import { Workshop } from "@models/workshop";
import { WorkshopAbsence } from "@models/workshop-absence";
import { Observable } from "rxjs/Observable"
import {
  FETCH_WORKSHOPS,
  POPULATE_WORKSHOPS,
  FETCH_WORKSHOPS_FAILURE,
  UPDATE_WORKSHOP,
  UPDATE_WORKSHOP_FAILURE,
  REPLACE_WORKSHOP,
  CREATE_WORKSHOP_ABSENCE,
  ADD_WORKSHOP_ABSENCE,
  CREATE_WORKSHOP_ABSENCE_FAILURE,
  REMOVE_WORKSHOP_ABSENCE,
  DELETE_WORKSHOP_ABSENCE,
  DELETE_WORKSHOP_ABSENCE_FAILURE,
  WORKSHOPS_ROLLOVER,
  WORKSHOPS_ROLLOVER_SUCCESS,
  WORKSHOPS_ROLLOVER_FAILURE
} from "../workshops"

@Injectable()
export class WorkshopEffects {

  constructor(
    private actions: Actions,
    private workshopService: WorkshopService,
  ) {}

  @Effect() index = this.actions
    .ofType(FETCH_WORKSHOPS)
    .map((action: Action) => action.payload)
    .switchMap((termId: number) => this.workshopService.index(termId)
      .map((workshops: Workshop[]) => ({ type: POPULATE_WORKSHOPS, payload: workshops }))
      .catch(() => Observable.of({ type: FETCH_WORKSHOPS_FAILURE }))
    )
    .share()

  @Effect() update = this.actions
    .ofType(UPDATE_WORKSHOP)
    .map((action: Action) => action.payload)
    .switchMap((workshop: Workshop) => this.workshopService.update(workshop)
      .map((workshop: Workshop) => ({ type: REPLACE_WORKSHOP, payload: workshop }))
      .catch(() => Observable.of({ type: UPDATE_WORKSHOP_FAILURE }))
    )
    .share()

  @Effect() createWorkshopAbsence = this.actions
    .ofType(CREATE_WORKSHOP_ABSENCE)
    .map((action: Action) => action.payload)
    .switchMap((wa: WorkshopAbsence) => this.workshopService.createWorkshopAbsence(wa)
      .map((wa: WorkshopAbsence) => ({ type: ADD_WORKSHOP_ABSENCE, payload: wa }))
      .catch(() => Observable.of({ type: CREATE_WORKSHOP_ABSENCE_FAILURE }))
    )
    .share()

  @Effect() deleteWorkshopAbsence = this.actions
    .ofType(DELETE_WORKSHOP_ABSENCE)
    .map((action: Action) => action.payload)
    .switchMap((wa: WorkshopAbsence) => this.workshopService.deleteWorkshopAbsence(wa)
      .map((wa: WorkshopAbsence) => ({ type: REMOVE_WORKSHOP_ABSENCE, payload: wa }))
      .catch(() => Observable.of({ type: DELETE_WORKSHOP_ABSENCE_FAILURE }))
    )
    .share()

  @Effect() rollover = this.actions
    .ofType(WORKSHOPS_ROLLOVER)
    .map((action: Action) => action.payload)
    .switchMap((params) => this.workshopService.rollover(params)
      .map((wa: WorkshopAbsence) => ({ type: WORKSHOPS_ROLLOVER_SUCCESS, payload: wa }))
      .catch(() => Observable.of({ type: WORKSHOPS_ROLLOVER_FAILURE }))
    )
    .share()

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/effects/workshop.ts